import React from 'react';

export const Visible: React.FC<React.PropsWithChildren<{value: boolean}>> = ({value, children}) => {
    if (value) return <>{children}</>;
    return <React.Fragment/>
};